import React from "react";
import { css } from "@emotion/react";
import PuffLoader from 'react-spinners/PuffLoader';

const override = css`
    display: block;
    margin: auto;
    border-color: red;
`;

const Loading = (props) => { 
    return (
        <div className="loading-wrap">
            <div className="loading-text">
                <PuffLoader color={'#fff'} loading={true} css={override} size={140} />
                <p>&nbsp;</p>
                Please wait. It takes 1-2 minutes.
            </div>
        </div>
    )
}

export default Loading;